import { useState, useEffect } from 'react'
import { getEmpsSupAPI } from '../services/employee'

function UseEmpsSupervisor(orgId, searchs) {
  const [data, setData] = useState([])
  useEffect(() => {
    const getData = async () => {
      const result = await getEmpsSupAPI({ orgId, searchs })
      if (!result) return

      const newData = result.result && result.result.map((d, i) => {
        return { value: d.code, label: d.username }
      })

      setData(newData)
    }
    if (orgId) {
      getData()
    }
  }, [orgId, searchs])

  return data
}

export default UseEmpsSupervisor
